import React, { Component } from "react";
import "../Styles/Order.css";

class Arrow extends Component {
    render() {
        let className = "pointer";

        this.props.order_status.date !== null && (className = className.concat(" completed"));
        this.props.current && (className = className.concat(" current"));
        this.props.next && (className = className.concat(" next"));
        this.props.previous && (className = className.concat(" previous"));
        this.props.last && (className = className.concat(" last"));
        this.props.second_last && (className = className.concat(" second-last"));
        this.props.closed && (className = className.concat(" closed"));
        this.props.dimmed && (className = className.concat(" dimmed"));

        return (
            <div style={{ zIndex: 1000 - this.props.position }} className={className}>
                <div className="pointer-text">
                    {this.props.label.charAt(0).toUpperCase() + this.props.label.slice(1).toLowerCase()}
                </div>
                {this.props.current && <div className="chevron chevron-inner" />}
                {this.props.current && <div className="chevron inner-2" />}
                {this.props.current && <div className="chevron inner-3" />}
            </div>
        );
    }
}

export default Arrow;



// WEBPACK FOOTER //
// ./src/views/Order/components/_Arrow.jsx